<template>
  <nav aria-label="breadcrumb" role="navigation" v-show="checkDisplay" id="Breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" v-for="page in pages" :key="page.name">
        <router-link v-if="page.path != ''" :to="`${page.path}`">{{ page.name }}</router-link>
<!--        <router-link v-if="page.name != ''" :to="{ name:`${page.name}`}">{{ page.name }}</router-link>-->
        <span v-else>{{ page.name }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
let pages = []

export default {
  name: 'breadcrumb',
  data() {
    return {
      pages:pages,
    }
  },
  props:{
    //ページ遷移時のイベントとして、rootでのセットで動くようにする
    presentPage:{
      type:String
    }
  },
  computed:{
    checkDisplay:function() {
      var checkList = ['/', '/login', '/register']
      return checkList.indexOf(this.$route.path) == -1
    },
  },
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
	},
  mounted:function() {this._log("mounted "+this.$options.name)
    this.makeBreadcrumbInfo()
	},
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)
    this.makeBreadcrumbInfo()
	},
  methods:{
		setFullPath:function() {
			let aQuery = ""
			if(this.$route.query != undefined) {
				aQuery = '?' + this.$route.query + '=' + this.$route.query.id
			}
//this._log(this.$route.query)
			return this.$route.path + aQuery
		},
    makeBreadcrumbInfo: function() {
      let aUrl = this.$route.path
      let aPageNameArray = aUrl.split("/")
//      if(this.$router.mode == "hash") {
        aPageNameArray.shift()
//      }
      this.pages = (aUrl != '/')?[{ path:'/', name: 'home' }]:[]

      let o = this.$route.matched
      let l = this.$route.matched.length
      let i
      for(i=0; i<l; i++) {
        if(i==l-1) {
//動的指定の場合 :id 二つの問題がある
//01 動的フラグ(:id)が変換されて認識されていない :id > ページのタイトルになって欲しいが :idのまま
//02 vue-router上で、children[ {path:":id"}]で定義できず、親/:idで定義しているため、親のディレクトリが認識できない
///products/goods/:pageId
//(.+)\/(.+)\/\:
//          let aResult = []
//          if((aResult = o[i].path.match(/(.+)\/(.+)\/\:/)) !== null ) {
//動的指定 処理内容
//01 '/:'の前名前を取得し、pathも取得
//02 それらを分けてpushし、配列を作成
//
//:前のディレクトリ名とURL
//this._log("RESULT" + aResult)
//            let aHref = this.$router.resolve({path:aResult[aResult.length-1]}).href
//            let aName = this.$router.resolve({path:aResult[aResult.length-1]}).name
//this._log(aHref)  
//this._log(aName)
//            this.pages.push({ path:aHref, name:aName })
//最後のページ名
//            let aUrl = this.$route.path
//this._log(aUrl)
//            let aPage = aUrl.match(/(.*)\/(.+)$/)[1]
//            this.pages.push({ path:'', name:aPage })
//          } else {

          if(o[i].path.indexOf(':') > -1) {
            this.pages.push({ path:'', name:decodeURI(aPageNameArray[i])})
          } else {
           this.pages.push({ path:'', name:o[i].name })
          }
        } else {
          if(o[i].path.indexOf(':') > -1) {
            this.pages.push({ path:o[i].path, name:decodeURI(aPageNameArray[i])})
          } else {
/*
ここでquery要素が定義されているものは、今のところlistのみ。
それを利用して定義されていたら、'?list=1'をurlに付加する。
定義されているqueryは取得できないので、metaに情報を追加しておく
addQuery:true, false
*/
						let aPath = o[i].path
						if(o[i].meta.addQuery) {
							aPath = aPath + '?list=1'
						}
            this.pages.push({ path:aPath, name:o[i].name })
          }
        }
      }
    },
  },
}
</script>

<style>
</style>